import { Settings } from 'luxon';
// Also listed in angular.json's polyfills, but the import has to stay: it is what
// brings the ambient $localize declaration into the app compilation. The spec
// compilation gets it through the "types" of tsconfig.spec.json instead.
import '@angular/localize/init';

Settings.throwOnInvalid = true;
